// Client for Ads Analytics.
//
// Read-only: nothing here changes a bid, a budget, a keyword or a campaign.
// Collection belongs to the Amazon Ads connection on the marketplace card.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/ads-analytics`;

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class NotConnectedError extends Error {
  constructor(message) {
    super(message || 'Amazon Ads not connected');
    this.notConnected = true;
  }
}

const call = async (url, options) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  // The feature being unavailable is an answer, not an error — it comes back
  // with success and says why, rather than rendering an account that does not
  // exist as a page of zeros.
  if (data.connected === false) throw new NotConnectedError(data.reason);
  return data;
};

const query = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v);
  });
  return search.toString();
};

export const getOverview = (token, params) =>
  call(`${BASE}/overview?${query(params)}`, { headers: headers(token) });
export const getPerformance = (token, params) =>
  call(`${BASE}/performance?${query(params)}`, { headers: headers(token) });
export const getDrill = (token, params) =>
  call(`${BASE}/drill?${query(params)}`, { headers: headers(token) });
export const getProducts = (token, params) =>
  call(`${BASE}/products?${query(params)}`, { headers: headers(token) });
export const getPlacements = (token, params) =>
  call(`${BASE}/placements?${query(params)}`, { headers: headers(token) });
export const getSearchTerms = (token, params) =>
  call(`${BASE}/search-terms?${query(params)}`, { headers: headers(token) });
export const getAlerts = (token, params) =>
  call(`${BASE}/alerts?${query(params)}`, { headers: headers(token) });
